import { parseColorHexRGB } from '@microsoft/fast-colors';
import { PaletteRGB, SwatchRGB } from '@microsoft/fast-components';
import { ColorHEX, getWebRGBA, PrimaryRapidColorHEX, RapidColorHEX, SecondaryRapidColorHEX, } from '../../_common';
/**
 * @internal
 */
const whiteRGB = parseColorHexRGB(ColorHEX.white);
export const whiteWebRGBA = (alpha = 1.0) => {
    return getWebRGBA(whiteRGB, alpha);
};
/**
 * @internal
 */
const blackRGB = parseColorHexRGB(ColorHEX.black);
export const blackWebRGBA = (alpha = 1.0) => {
    return getWebRGBA(blackRGB, alpha);
};
/**
 * @internal
 */
export const rapidBGColorHEX = '#585858';
const rapidBGColor = parseColorHexRGB(rapidBGColorHEX);
export const rapidDefaultFillColor = SwatchRGB.create(rapidBGColor.r, rapidBGColor.g, rapidBGColor.b);
/**
 * @internal
 */
const rapidCardBGColor = parseColorHexRGB('#202126');
export const rapidDefaultCardFillColor = SwatchRGB.create(rapidCardBGColor.r, rapidCardBGColor.g, rapidCardBGColor.b);
export const rapidDefaultCardPalette = PaletteRGB.from(rapidDefaultCardFillColor);
/**
 * Primary Blue Color
 *
 * @internal
 */
const primaryBlueRGB = parseColorHexRGB(PrimaryRapidColorHEX.blue);
export const primaryBlueWebRGBA = (alpha = 1.0) => {
    return getWebRGBA(primaryBlueRGB, alpha);
};
export const accentBlueSwatch = SwatchRGB.create(primaryBlueRGB.r, primaryBlueRGB.g, primaryBlueRGB.b);
export const accentBluePalette = PaletteRGB.from(accentBlueSwatch);
/**
 * Primary Purple Color
 *
 * @internal
 */
const primaryPurpleRGB = parseColorHexRGB(PrimaryRapidColorHEX.purple);
export const primaryPurpleWebRGBA = (alpha = 1.0) => {
    return getWebRGBA(primaryPurpleRGB, alpha);
};
/**
 * Secondary Orange Color
 *
 * @internal
 */
const secondaryOrangeRGB = parseColorHexRGB(SecondaryRapidColorHEX.orange);
export const secondaryOrangeWebRGBA = (alpha = 1.0) => {
    return getWebRGBA(secondaryOrangeRGB, alpha);
};
/**
 * Secondary Teal Color
 *
 * @internal
 */
const secondaryTealRGB = parseColorHexRGB(SecondaryRapidColorHEX.teal);
export const secondaryTealWebRGBA = (alpha = 1.0) => {
    return getWebRGBA(secondaryTealRGB, alpha);
};
/**
 * Long/Short Colors
 *
 * @internal
 */
const longGreenRGB = parseColorHexRGB(RapidColorHEX.longGreen);
export const longGreenWebRGBA = (alpha = 1.0) => {
    return getWebRGBA(longGreenRGB, alpha);
};
const shortPinkRGB = parseColorHexRGB(RapidColorHEX.chartPink);
export const shortPinkWebRGBA = (alpha = 1.0) => {
    return getWebRGBA(shortPinkRGB, alpha);
};
/**
 * Warning/Error/Success Colors
 *
 * @internal
 */
const warningYellowRGB = parseColorHexRGB(RapidColorHEX.warningYellow);
export const warningYellowWebRGBA = (alpha = 1.0) => {
    return getWebRGBA(warningYellowRGB, alpha);
};
/**
 * Charts Colors
 *
 * @internal
 */
const chartPinkRGB = parseColorHexRGB(RapidColorHEX.chartPink);
export const chartPinkWebRGBA = (alpha = 1.0) => {
    return getWebRGBA(chartPinkRGB, alpha);
};
